export default [// 发运单
    {
        path: "shipment/list",
        name: "spBill",
        component: () => import(/* webpackChunkName: "shipment" */ "@/views/boss/shipment/index"),
    },
    // 发运单添加编辑
    {
        path: "shipment/upadte/:type",
        name: "spBillupdate",
        component: () => import(/* webpackChunkName: "shipment" */ "@/views/boss/shipment/update/index"),
        meta: {
            bread: false,
        }
    },

    // 子单据
    {
        path: "shipment/child",
        name: "spBillChild",
        component: () => import(/* webpackChunkName: "shipment" */ "@/views/boss/shipment/child/index"),
    },

    // 子单据
    {
        path: "shipment/child/:type",
        name: "spBillChildDetail",
        component: () => import(/* webpackChunkName: "shipment" */ "@/views/boss/shipment/child/detail"),
    }]